import { lazy } from "react";

export { default as Notification } from "./notifications/Notification";
export const LazyNotification = lazy(() => import("./notifications/Notification"));

export { default as Notifications } from "./notifications/Notifications";
export const LazyNotifications = lazy(() => import("./notifications/Notifications"));

export { default as AllNotifications } from "./notifications/AllNotifications";
export const LazyAllNotifications = lazy(() => import("./notifications/AllNotifications"));

export { default as NewVideoFormDialog } from "./dialogs/newVideoFormDialog/NewVideoFormDialog";
export const LazyNewVideoFormDialog = lazy(() => import("./dialogs/newVideoFormDialog/NewVideoFormDialog"));

export { default as VideoPlayerDialog } from "./dialogs/videoPlayerDialog/VideoPlayerDialog";
export const LazyVideoPlayerDialog = lazy(() => import("./dialogs/videoPlayerDialog/VideoPlayerDialog"));

export { default as SnackbarAPI } from "./snackbar/SnackbarAPI";
export const LazySnackbarAPI = lazy(() => import("./snackbar/SnackbarAPI"));

export { default as CustomDialog } from "./dialogs/customDialog/CustomDialog";
export const LazyCustomDialog = lazy(() => import("./dialogs/customDialog/CustomDialog"));

export { default as CustomFullScreenDialogs } from "./dialogs/customFullScreenDialog/CustomFullScreenDialog";
export const LazyCustomFullScreenDialogs = lazy(
	() => import("./dialogs/customFullScreenDialog/CustomFullScreenDialog")
);

export { default as RichTextEditorModal } from "./modals/richTextEditorModal/RichTextEditorModal";
export const LazyRichTextEditorModal = lazy(() => import("./modals/richTextEditorModal/RichTextEditorModal"));

export { default as CustomFilter } from "./customFilter/CustomFilter.jsx";
export const LazyCustomFilter = lazy(() => import("./customFilter/CustomFilter.jsx"));

export { default as CustomFloatingFilter } from "./customFloatingFilter/CustomFloatingFilter.jsx";
export const LazyCustomFloatingFilter = lazy(() => import("./customFloatingFilter/CustomFloatingFilter.jsx"));

export { default as CustomFilterForOpenEnrollment } from "./customFilterForOpenEnrollment/CustomFilterForOpenEnrollment.jsx";
export const LazyCustomFilterForOpenEnrollment = lazy(
	() => import("./customFilterForOpenEnrollment/CustomFilterForOpenEnrollment.jsx")
);

export { default as CustomFloatingFilterForOpenEnrollment } from "./customFloatingFilterForOpenEnrollment/CustomFloatingFilterForOpenEnrollment.jsx";
export const LazyCustomFloatingFilterForOpenEnrollment = lazy(
	() => import("./customFloatingFilterForOpenEnrollment/CustomFloatingFilterForOpenEnrollment.jsx")
);

export { default as CustomImageDialog } from "./dialogs/customImageDialog/CustomImageDialog";
export const LazyCustomImageDialog = lazy(() => import("./dialogs/customImageDialog/CustomImageDialog"));

export { default as CustomImageDialogWithTitle } from "./dialogs/customImageDialogWithTitle/CustomImageDialogWithTitle";
export const LazyCustomImageDialogWithTitle = lazy(
	() => import("./dialogs/customImageDialogWithTitle/CustomImageDialogWithTitle")
);

export { default as CustomPdfViewWithTitleDialog } from "./customPdfViewWithTitleDialog/CustomPdfViewWithTitleDialog";
export const LazyCustomPdfViewWithTitleDialog = lazy(
	() => import("./customPdfViewWithTitleDialog/CustomPdfViewWithTitleDialog")
);

export { default as CustomDatePickerDialog } from "./dialogs/customDatePickerDialog/CustomDatePickerDialog.jsx";

export { default as CustomFullScreenDialog } from "./dialogs/customFullScreenDialog/CustomFullScreenDialog";
export const LazyCustomFullScreenDialog = lazy(() => import("./dialogs/customFullScreenDialog/CustomFullScreenDialog"));

export { default as CustomImageUploadDialog } from "./dialogs/customImageUploadDialog/CustomImageUploadDialog";
export const LazyCustomImageUploadDialog = lazy(
	() => import("./dialogs/customImageUploadDialog/CustomImageUploadDialog")
);

export { default as CustomPagination } from "./customPagination/CustomPagination";

export { default as CustomWaivedBenifitDialog } from "./dialogs/customWaivedBenifitDialog/CustomWaivedBenifitDialog";
export const LazyCustomWaivedBenifitDialog = lazy(
	() => import("./dialogs/customWaivedBenifitDialog/CustomWaivedBenifitDialog")
);

export { default as FullScreenCustomPlanViewDialog } from "./dialogs/FullScreenCustomPlanViewDialog/FullScreenCustomPlanViewDialog";
export const LazyFullScreenCustomPlanViewDialog = lazy(
	() => import("./dialogs/FullScreenCustomPlanViewDialog/FullScreenCustomPlanViewDialog")
);

export { default as DialogStaticForm } from "./dialogStaticForm/DialogStaticForm";

// charts

export { default as BarChart } from "./charts/barChart/BarChart";
export { default as BarChartNew } from "./charts/barChart/BarChartNew";
export { default as PieChart } from "./charts/pieChart/PieChart";
export { default as AreaChart } from "./charts/areaChart/AreaChart";
export { default as DonutChart } from "./charts/donutChart/DonutChart";
// export { default as PieChartThreeD } from "./charts/pieChart/PieChartThreeD";

//maps

export { default as CustomMapView } from "./customMapView/CustomMapView";

//feature alert
export { default as FeatureAlert } from "./featureAlert/FeatureAlert";
export { default as MultiBarChart } from "./charts/multiBarChart/MultiBarChart";

// export { default as CustomOptionSelect } from "./customOptionSelect/CustomOptionSelect";

export { default as AutoLogout } from "./autoLogout/AutoLogout";

export { default as DisclaimerTable } from "./disclaimerTable/DisclaimerTable";
export { default as ClinicCardDisclaimerTable } from "./disclaimerTable/clinicCardDisclaimerTable/ClinicCardDisclaimerTable";
